// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mn2q","title":"styles_title__3MbPb"};